import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  Tabs: {
    id: 'Tabs',
    defaultMessage: 'Tabs',
  },
  Title: {
    id: 'Title',
    defaultMessage: 'Titolo di fianco alle tab',
  },
  addSectionButton: {
    id: 'Aggiungi una tab',
    defaultMessage: 'Aggiungi una tab',
  },
  bgColor: {
    id: 'Colore di sfondo',
    defaultMessage: 'Colore di sfondo',
  },
  bgColorTitle: {
    id: 'Sfondo dell\'intestazione',
    defaultMessage: 'Sfondo dell\'intestazione',
  },
});

export const PanelSchema = {
  title: 'Tabs',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['panel_title'],
    },
  ],
  properties: {
    panel_title: {
      title: 'Tabs title',
    },
  },
  required: [],
};

const TabsSchema = (props) => {
  const intl = useIntl();

  return {
    title: 'Blocco Tabs',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'bg_title', 'styles', 'data'],
      },
    ],
    properties: {
      title: {
        title: intl.formatMessage(messages.Title),
      },
      bg_title: {
        widget: 'color_picker',
        title: intl.formatMessage(messages.bgColorTitle),
        default: 'light-gray',
        colors: [
          {name: 'transparent', label: 'Nessuno'},
          {name: 'light-gray', label: 'Grigio chiaro'},
        ],
      },
      styles: {
        widget: 'object',
        schema: {
          title: 'Stile',
          fieldsets: [
            {
              id: 'default',
              fields: ['bg', 'full-width:bool'],
              title: 'Default',
            },
          ],
          properties: {
            bg: {
              widget: 'color_picker',
              title: intl.formatMessage(messages.bgColor),
              default: 'transparent',
              colors: [
                {name: 'transparent', label: 'Nessuno'},
                {name: 'light-gray', label: 'Grigio chiaro'},
              ],
            },
            'full-width:bool': {
              title: 'A tutta larghezza',
              type: 'boolean',
            },
          },
          required: [],
        },
      },
      data: {
        title: intl.formatMessage(messages.Tabs),
        type: 'panels',
        schema: PanelSchema,
      },
    },
    required: [],
  }
};

export default TabsSchema;
